import React, { FC, SVGProps } from "react"
import { colors } from "./colors"

export type IconSvgProps = SVGProps<SVGSVGElement> & {
  size?: number
}

export function CardIcon(props: IconSvgProps) {
  return (
    <svg
      width="24px"
      height="15px"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.68264 15H18.3174C19.2332 15 20 14.2606 20 13.331V1.66901C20 0.760563 19.2545 0 18.3174 0H1.68264C0.766773 0 0 0.739437 0 1.66901V13.331C0.0212993 14.2394 0.766773 15 1.68264 15ZM2.15122 2.11268H17.8914V3.8662H2.15122V2.11268ZM2.15122 7.30986H17.8914V12.8873H2.15122V7.30986Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CryptoIcon(props: IconSvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="19"
      viewBox="0 0 44 48"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M26.53 24a4.399 4.399 0 0 1 0 8.797h-7.258V15.203h7.257a4.399 4.399 0 0 1 0 8.797m0 0h-7.257m0 8.797h-2.2m2.2-17.594h-2.2m4.399 19.793v-2.199m4.398 2.199v-2.199m-4.398-17.594v-2.199m4.398 2.199v-2.199"
      />
      <circle
        cx="24"
        cy="24"
        r="21.5"
        fill="none"
        strokeWidth="4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="clear"
      />
    </svg>
  )
}

export const EyeClosedIcon: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size || width}
      height={size || height}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2.69 6.705a.75.75 0 0 0-1.38.59zm12.897 6.624l-.274-.698zm7.102-6.034a.75.75 0 0 0-1.378-.59zM19 11.13l-.513-.547zm-7 2.121c-3.224 0-5.539-1.605-7.075-3.26a13.637 13.637 0 0 1-1.702-2.28a11.707 11.707 0 0 1-.507-.946a3.903 3.903 0 0 1-.022-.049l-.004-.01l-.001-.001L2 7a76 76 0 0 0-.69.296h.001l.001.003l.003.006a3.837 3.837 0 0 0 .04.088a13.202 13.202 0 0 0 .58 1.084c.41.69 1.034 1.61 1.89 2.533C5.54 12.855 8.224 14.75 12 14.75zm3.313-.62c-.97.383-2.071.62-3.313.62v1.5c1.438 0 2.725-.276 3.862-.723zM22 7l-.69-.296h.001v.002l-.007.013a8.017 8.017 0 0 1-.151.313a13.298 13.298 0 0 1-2.666 3.55l1.026 1.094a14.802 14.802 0 0 0 3.122-4.26l.039-.085l.01-.024l.004-.007v-.003h.001v-.001zm-3.513 3.582c-.86.806-1.913 1.552-3.174 2.049l.549 1.396c1.473-.58 2.685-1.444 3.651-2.351z"
      />
      <path
        fill="currentColor"
        d="M12.75 14a.75.75 0 0 0-1.5 0zm3.466-1.08a.75.75 0 1 0-1.257.818zm-7.175.818a.75.75 0 0 0-1.257-.818zm-2.67 1.353a.75.75 0 0 0 1.258.818zm13.16-4.492a.75.75 0 1 0-1.061 1.06zm.439 2.56a.75.75 0 1 0 1.06-1.06zM11.25 16.5a.75.75 0 0 0 1.5 0zm5.121-.59a.75.75 0 1 0 1.258-.819zm-10.84-4.25a.75.75 0 1 0-1.061-1.061zm-2.561.439a.75.75 0 1 0 1.06 1.06zm4.814.82l-1.413 2.172l1.258.818l1.412-2.171zm10.686-1.26l1.5 1.5l1.06-1.06l-1.5-1.5zM11.25 14v2.5h1.5V14zm3.709-.262l1.412 2.171l1.258-.818l-1.413-2.171zm-10.49-3.14l-1.5 1.5L4.03 13.16l1.5-1.5z"
        opacity="0.5"
      />
    </svg>
  )
}
export const EyeOpenedIcon: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size || width}
      height={size || height}
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.5">
        <path
          d="M3.275 15.296C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296C4.972 6.5 7.818 4 12 4c4.182 0 7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20c-4.182 0-7.028-2.5-8.725-4.704Z"
          opacity="0.5"
        />
        <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0Z" />
      </g>
    </svg>
  )
}
export const GoogleIcon: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 262"
      width={size || width}
      height={size || height}
      {...props}
    >
      <path
        fill="#4285f4"
        d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622l38.755 30.023l2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      />
      <path
        fill="#34a853"
        d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055c-34.523 0-63.824-22.773-74.269-54.25l-1.531.13l-40.298 31.187l-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      />
      <path
        fill="#fbbc05"
        d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82c0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602z"
      />
      <path
        fill="#eb4335"
        d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0C79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      />
    </svg>
  )
}
export const HamburgerIcon: FC<IconSvgProps> = ({
  size = 10,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      {...props}
      width={size || width}
      height={size || height}
      viewBox="0 0 10 8"
      fill="none"
    >
      <path
        d="M0 1C0 0.447715 0.447715 0 1 0H9C9.55228 0 10 0.447715 10 1C10 1.55228 9.55228 2 9 2H1C0.447716 2 0 1.55228 0 1Z"
        fill="#646464"
      />
      <path
        d="M0 7C0 6.44772 0.447715 6 1 6H9C9.55228 6 10 6.44772 10 7C10 7.55228 9.55228 8 9 8H1C0.447716 8 0 7.55228 0 7Z"
        fill="#646464"
      />
    </svg>
  )
}

export const PlusIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      width={size || width}
      height={size || height}
      {...props}
    >
      <path
        fill="white"
        d="M7.47273 18V0H10.5273V18H7.47273ZM0 10.5273V7.47273H18V10.5273H0Z"
      />
    </svg>
  )
}

export const ArrowDown: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size || width}
      height={size || height}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L12 14.9393L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967Z"
        fill="white"
      />
    </svg>
  )
}

export const EraserIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M15 14V12.0688H9.994L14.0903 7.98196C14.6721 7.40118 14.9989 6.61364 14.9989 5.79249C14.9989 4.97133 14.6721 4.18379 14.0903 3.60301L11.3876 0.906602C10.8055 0.326099 10.0162 0 9.19314 0C8.3701 0 7.58075 0.326099 6.99863 0.906602L0.908686 6.98258C0.326849 7.56336 0 8.3509 0 9.17205C0 9.9932 0.326849 10.7807 0.908686 11.3615L2.98706 13.4351L3.55323 14H15ZM8.36808 2.2705C8.58724 2.05189 8.88445 1.92908 9.19435 1.92908C9.50425 1.92908 9.80146 2.05189 10.0206 2.2705L12.7232 4.96932C12.9423 5.18797 13.0654 5.4845 13.0654 5.79369C13.0654 6.10288 12.9423 6.39941 12.7232 6.61807L10.3618 8.9741L6.00663 4.62895L8.36808 2.2705ZM4.35409 12.0688L2.27572 9.99522C2.05661 9.77656 1.93351 9.48003 1.93351 9.17084C1.93351 8.86165 2.05661 8.56512 2.27572 8.34647L4.63717 5.99043L8.99232 10.3356L7.25752 12.0688H4.35409Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const RedoIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.28536 3.7905H12.0965L9.81088 1.57059L11.4279 0L15.6648 4.11516C15.7711 4.21824 15.8554 4.34066 15.9129 4.4754C15.9704 4.61015 16 4.75459 16 4.90045C16 5.04632 15.9704 5.19075 15.9129 5.3255C15.8554 5.46024 15.7711 5.58266 15.6648 5.68574L11.4279 9.8009L9.81088 8.23032L12.0965 6.01041H6.28536C5.22455 6.01041 4.2072 6.4197 3.45709 7.14825C2.70699 7.8768 2.28559 8.86492 2.28559 9.89525C2.28559 10.9256 2.70699 11.9137 3.45709 12.6422C4.2072 13.3708 5.22455 13.7801 6.28536 13.7801H11.4279V16H6.28536C4.61838 16 3.01967 15.3568 1.84094 14.212C0.662205 13.0671 0 11.5143 0 9.89525C0 8.27617 0.662205 6.7234 1.84094 5.57854C3.01967 4.43367 4.61838 3.7905 6.28536 3.7905Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const UndoIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.71464 3.7905H3.90354L6.18912 1.57059L4.57207 0L0.335166 4.11516C0.228913 4.21824 0.144622 4.34066 0.0871119 4.4754C0.0296016 4.61015 0 4.75459 0 4.90045C0 5.04632 0.0296016 5.19075 0.0871119 5.3255C0.144622 5.46024 0.228913 5.58266 0.335166 5.68574L4.57207 9.8009L6.18912 8.23032L3.90354 6.01041H9.71464C10.7754 6.01041 11.7928 6.4197 12.5429 7.14825C13.293 7.8768 13.7144 8.86492 13.7144 9.89525C13.7144 10.9256 13.293 11.9137 12.5429 12.6422C11.7928 13.3708 10.7754 13.7801 9.71464 13.7801H4.57207V16H9.71464C11.3816 16 12.9803 15.3568 14.1591 14.212C15.3378 13.0671 16 11.5143 16 9.89525C16 8.27617 15.3378 6.7234 14.1591 5.57854C12.9803 4.43367 11.3816 3.7905 9.71464 3.7905Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const TrashIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 15 17"
      fill="none"
    >
      <path
        d="M0 5.84375H1.07143V14.875C1.07143 15.4386 1.29719 15.9791 1.69906 16.3776C2.10092 16.7761 2.64596 17 3.21429 17H11.7857C12.354 17 12.8991 16.7761 13.3009 16.3776C13.7028 15.9791 13.9286 15.4386 13.9286 14.875V5.84375H15V3.71875H11.25V2.125C11.25 1.56141 11.0242 1.02091 10.6224 0.622398C10.2205 0.223883 9.67546 0 9.10714 0H5.89286C5.32454 0 4.77949 0.223883 4.37763 0.622398C3.97576 1.02091 3.75 1.56141 3.75 2.125V3.71875H0V5.84375ZM11.7857 14.875H3.21429V5.84375H11.7857V14.875ZM5.89286 2.125H9.10714V3.71875H5.89286V2.125Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const BrushIcon: FC<IconSvgProps> = ({
  size = 18,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M0.190838 10.6898C0.0374308 11.0034 -0.0254351 11.3536 0.00932087 11.701C0.0440769 12.0485 0.175074 12.3793 0.387557 12.6562C0.955106 13.3793 1.67791 13.9654 2.50247 14.3711C3.32702 14.7768 4.23219 14.9917 5.15097 14.9999C6.50795 15.0074 7.81248 14.4759 8.77837 13.522C9.74425 12.5681 10.2926 11.2697 10.3031 9.91168C10.3016 9.68149 10.2812 9.45182 10.2422 9.22496L14.2844 4.6875C14.6468 4.28199 14.8839 3.78 14.967 3.24235C15.0501 2.70469 14.9756 2.15446 14.7525 1.65834C14.5294 1.16221 14.1673 0.741486 13.7101 0.447149C13.2529 0.152812 12.7203 -0.00250135 12.1766 3.04672e-05C11.7791 -0.00181361 11.3856 0.0807966 11.0223 0.242403C10.6589 0.40401 10.334 0.640935 10.0689 0.937524L5.91677 5.62499C4.82658 5.63148 3.77928 6.05084 2.9855 6.79872C2.19171 7.5466 1.71032 8.56754 1.63813 9.65621C1.33022 9.69505 1.03678 9.80983 0.784165 9.99024C0.531548 10.1706 0.327667 10.411 0.190838 10.6898ZM11.4741 2.18908C11.639 2.0026 11.8712 1.88932 12.1195 1.87415C12.3679 1.85899 12.6121 1.94318 12.7984 2.10822C12.9848 2.27325 13.0979 2.50561 13.1131 2.75416C13.1283 3.00272 13.0441 3.24712 12.8792 3.4336L9.42024 7.32888C9.03588 6.82702 8.54677 6.41511 7.987 6.12186L11.4741 2.18908ZM3.51164 9.91168C3.51164 9.259 3.77071 8.63306 4.23186 8.17154C4.69301 7.71003 5.31847 7.45076 5.97063 7.45076C6.6228 7.45076 7.24825 7.71003 7.7094 8.17154C8.17055 8.63306 8.42962 9.259 8.42962 9.91168C8.42035 10.7728 8.06978 11.595 7.45497 12.1976C6.84016 12.8001 6.01144 13.1337 5.15097 13.1249C4.51971 13.1161 3.89827 12.9673 3.33135 12.6893C2.76443 12.4113 2.26614 12.0109 1.87232 11.5171C2.56083 11.5171 3.51164 10.964 3.51164 9.91168Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const LockedIcon: FC<IconSvgProps> = ({
  size = 15,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 12 16"
      fill="none"
    >
      <path
        d="M1.25174 16H10.765C11.4492 16 12 15.4359 12 14.735V7.74359C12 7.04273 11.4492 6.47863 10.765 6.47863H10.7316V4.80342C10.7316 2.15385 8.62865 0 6.04172 0C3.4548 0 1.35188 2.15385 1.35188 4.80342V6.47863H1.23505C0.550765 6.47863 0 7.04273 0 7.74359V14.735C0.0166898 15.4359 0.567455 16 1.25174 16ZM3.40473 4.80342C3.40473 3.31624 4.58971 2.10256 6.04172 2.10256C7.49374 2.10256 8.67872 3.31624 8.67872 4.80342V6.47863H3.40473V4.80342Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const UnlockedIcon: FC<IconSvgProps> = ({
  size = 23,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 21 24"
      fill="none"
    >
      <path
        d="M7.50255 10.5026V6.75326C7.50269 6.32205 7.5958 5.89594 7.77553 5.50398C7.95527 5.11201 8.21741 4.76341 8.54408 4.48193C8.87075 4.20046 9.25426 3.99273 9.66849 3.8729C10.0827 3.75307 10.5179 3.72397 10.9444 3.78757C11.6669 3.91008 12.3218 4.28695 12.7907 4.85008C13.2597 5.41322 13.5117 6.12549 13.5014 6.85824V7.50312C13.5014 7.70199 13.5804 7.89272 13.721 8.03335C13.8617 8.17398 14.0524 8.25298 14.2513 8.25298H16.5009C16.6997 8.25298 16.8905 8.17398 17.0311 8.03335C17.1717 7.89272 17.2507 7.70199 17.2507 7.50312V6.75326C17.2513 5.84579 17.0689 4.94752 16.7144 4.11217C16.3599 3.27682 15.8405 2.52155 15.1874 1.89153C14.5343 1.26151 13.7608 0.769676 12.9132 0.44545C12.0656 0.121224 11.1614 -0.0287355 10.2545 0.00453848C6.59898 0.139513 3.75326 3.25517 3.75326 6.91448V10.5026H3.00341C2.20791 10.5026 1.44499 10.8186 0.882488 11.3811C0.319984 11.9436 0.00397301 12.7065 0.00397301 13.502V21.0006C0.00397301 21.7961 0.319984 22.559 0.882488 23.1215C1.44499 23.684 2.20791 24 3.00341 24H18.0006C18.7961 24 19.559 23.684 20.1215 23.1215C20.684 22.559 21 21.7961 21 21.0006V13.502C21 12.7065 20.684 11.9436 20.1215 11.3811C19.559 10.8186 18.7961 10.5026 18.0006 10.5026H7.50255Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ArrowRightIcon: FC<IconSvgProps> = ({
  size = 15,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 1L5.58579 5.58579C6.36683 6.36683 6.36683 7.63316 5.58579 8.41421L0.999999 13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
export const ArrowLeftIcon: FC<IconSvgProps> = ({
  size = 15,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L2.41421 8.41421C1.63317 7.63317 1.63317 6.36684 2.41421 5.58579L7 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const ThumbIcon: FC<IconSvgProps> = ({
  size = 15,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 40 40"
      fill="none"
    >
      <circle cx="20" cy="20" r="20" fill="white" />
      <rect
        opacity="0.4"
        x="14.6659"
        y="12"
        width="2.45186"
        height="15.9371"
        rx="1.22593"
        transform="rotate(6 14.6659 12)"
        fill="black"
      />
      <rect
        opacity="0.6"
        x="20.1145"
        y="12"
        width="2.45186"
        height="15.9371"
        rx="1.22593"
        transform="rotate(6 20.1145 12)"
        fill="black"
      />
      <rect
        opacity="0.8"
        x="25.5615"
        y="12"
        width="2.45186"
        height="15.9371"
        rx="1.22593"
        transform="rotate(6 25.5615 12)"
        fill="black"
      />
    </svg>
  )
}

export const CloseIcon: FC<IconSvgProps> = ({
  size = 14,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M13.6716 0.328446C13.5675 0.224323 13.444 0.141722 13.3081 0.0853653C13.1721 0.0290081 13.0264 0 12.8792 0C12.7321 0 12.5863 0.0290081 12.4504 0.0853653C12.3144 0.141722 12.1909 0.224323 12.0869 0.328446L6.99987 5.4155L1.91282 0.328446C1.70268 0.118311 1.41768 0.000258454 1.1205 0.000258456C0.823327 0.000258458 0.538323 0.118311 0.328188 0.328446C0.118053 0.538581 2.21413e-09 0.823585 0 1.12076C-2.21413e-09 1.41794 0.118053 1.70294 0.328188 1.91308L5.41524 7.00013L0.328188 12.0872C0.118053 12.2973 0 12.5823 0 12.8795C0 13.1767 0.118053 13.4617 0.328188 13.6718C0.538323 13.8819 0.823327 14 1.1205 14C1.41768 14 1.70268 13.8819 1.91282 13.6718L6.99987 8.58476L12.0869 13.6718C12.2971 13.8819 12.5821 14 12.8792 14C13.1764 14 13.4614 13.8819 13.6716 13.6718C13.8817 13.4617 13.9997 13.1767 13.9997 12.8795C13.9997 12.5823 13.8817 12.2973 13.6716 12.0872L8.5845 7.00013L13.6716 1.91308C13.7757 1.80907 13.8583 1.68556 13.9146 1.54961C13.971 1.41366 14 1.26793 14 1.12076C14 0.973591 13.971 0.827865 13.9146 0.691914C13.8583 0.555962 13.7757 0.432453 13.6716 0.328446Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const PlayIcon: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      {...props}
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 11.5359C25.6667 13.0755 27 13.8453 27 15C27 16.1547 25.6667 16.9245 23 18.4641L6.5 27.9904C3.83333 29.53 2.5 30.2998 1.5 29.7224C0.499999 29.1451 0.499999 27.6055 0.499999 24.5263L0.5 5.47373C0.5 2.39452 0.5 0.854917 1.5 0.277567C2.5 -0.299784 3.83333 0.470017 6.5 2.00962L23 11.5359Z"
        fill="white"
      />
    </svg>
  )
}
export const WarningIcon: FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      {...props}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"></path>
    </svg>
  )
}
export const CustomFaceIcon: FC<IconSvgProps> = ({ size, ...props }) => {
  return (
    <svg
      width={size || undefined}
      height={size || undefined}
      {...props}
      viewBox="0 0 119 112"
      fill="none"
    >
      <path
        d="M87.7539 14.1939L91.8053 15.9124C93.1641 16.4872 94.3226 17.4452 95.1367 18.6673C95.9508 19.8894 96.3847 21.3218 96.3843 22.7863V35.2453C96.3965 42.6886 98.8355 49.9286 103.338 55.8857C98.8355 61.8428 96.3965 69.0828 96.3843 76.5261V88.9851C96.3862 90.4475 95.9552 91.8783 95.1446 93.1002C94.334 94.3221 93.1794 95.2814 91.8241 95.859L87.7727 97.5775C86.8346 97.9442 85.9802 98.4937 85.2602 99.1936C84.5401 99.8935 83.9691 100.729 83.5809 101.652C83.1927 102.575 82.9952 103.565 83.0001 104.565C83.005 105.564 83.2122 106.553 83.6094 107.472C84.0067 108.39 84.5859 109.221 85.3127 109.914C86.0396 110.607 86.8993 111.148 87.841 111.506C88.7827 111.863 89.7872 112.03 90.7951 111.996C91.8029 111.961 92.7936 111.727 93.7085 111.307L97.7599 109.588C101.818 107.863 105.277 104.998 107.712 101.347C110.146 97.6956 111.449 93.4178 111.459 89.0411V76.5261C111.464 72.1137 112.979 67.8335 115.756 64.3847L116.17 63.8617C118.002 61.5927 119 58.7731 119 55.867C119 52.9609 118.002 50.1414 116.17 47.8724L115.756 47.368C112.983 43.9243 111.469 39.6513 111.459 35.2453V22.7863C111.449 18.4097 110.146 14.1318 107.712 10.4806C105.277 6.82931 101.818 3.96439 97.7599 2.23927L93.7085 0.520792C91.8843 -0.192159 89.8517 -0.172422 88.0421 0.575819C86.2324 1.32406 84.788 2.7419 84.0156 4.52842C83.2432 6.31494 83.2036 8.32951 83.905 10.1446C84.6065 11.9596 85.9939 13.4322 87.7727 14.2499L87.7539 14.1939Z"
        fill="currentColor"
      />
      <path
        d="M3.19024 64.5402C5.9205 67.9943 7.40984 72.2811 7.41493 76.7003V89.1785C7.42524 93.5619 8.70632 97.8464 11.1001 101.503C13.4939 105.16 16.8957 108.03 20.8858 109.757L24.8696 111.478C26.6633 112.192 28.662 112.173 30.4415 111.423C32.221 110.674 33.6412 109.254 34.4007 107.465C35.1602 105.675 35.1993 103.658 34.5095 101.84C33.8197 100.022 32.4555 98.547 30.7063 97.7281L26.7225 96.0069C25.3985 95.4322 24.2691 94.4801 23.4727 93.2673C22.6763 92.0546 22.2473 90.6337 22.2384 89.1785V76.7003C22.2278 69.2453 19.8293 61.9937 15.4011 56.0281C19.8293 50.0624 22.2278 42.8108 22.2384 35.3558V22.8776C22.2365 21.4129 22.6604 19.9799 23.4574 18.7561C24.2545 17.5323 25.3898 16.5716 26.7225 15.9931L30.7063 14.2719C32.4555 13.453 33.8197 11.9781 34.5095 10.1602C35.1993 8.34236 35.1602 6.32469 34.4007 4.53541C33.6412 2.74613 32.221 1.3261 30.4415 0.576709C28.662 -0.172686 26.6633 -0.192457 24.8696 0.521594L20.8858 2.24272C16.8957 3.9705 13.4939 6.83984 11.1001 10.4967C8.70632 14.1536 7.42524 18.4381 7.41493 22.8215V35.2997C7.40984 39.7189 5.9205 44.0057 3.19024 47.4598L2.78259 47.9836C0.98136 50.2562 0 53.08 0 55.9906C0 58.9012 0.98136 61.7251 2.78259 63.9976L3.19024 64.5402Z"
        fill="currentColor"
      />
      <path
        d="M38.5 54C42.6421 54 46 50.6421 46 46.5C46 42.3579 42.6421 39 38.5 39C34.3579 39 31 42.3579 31 46.5C31 50.6421 34.3579 54 38.5 54Z"
        fill={colors.primary.pink}
      />
      <path
        d="M79.5 54C83.6421 54 87 50.6421 87 46.5C87 42.3579 83.6421 39 79.5 39C75.3579 39 72 42.3579 72 46.5C72 50.6421 75.3579 54 79.5 54Z"
        fill={colors.primary.pink}
      />
      <path
        d="M44.3564 66.23C44.1181 67.2557 43.9986 68.3045 44 69.3565C44.0171 72.9154 45.3492 76.3477 47.7496 79.0173C50.15 81.6869 53.4558 83.4128 57.0546 83.8752C60.6533 84.3377 64.3011 83.5053 67.3218 81.5323C70.3426 79.5593 72.5317 76.5795 73.4834 73.145C74.1171 70.8816 74.1686 68.4994 73.6334 66.2116C73.3347 65.009 72.6322 63.9398 71.6389 63.1759C70.6456 62.412 69.4192 61.9979 68.1569 62H49.8517C48.5836 61.9947 47.3509 62.4096 46.3534 63.1774C45.356 63.9452 44.6522 65.0209 44.3564 66.23Z"
        fill={colors.primary.pink}
      />
    </svg>
  )
}

export const UploadIcon: FC<IconSvgProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || undefined}
      height={height || undefined}
      {...props}
      viewBox="0 0 121 120"
      fill="none"
    >
      <path
        d="M25.5769 22.82C20.2204 23.6183 15.1799 25.8517 10.9902 29.2834C6.8005 32.715 3.61791 37.2168 1.78011 42.3111C-0.0576896 47.4054 -0.482149 52.9022 0.551774 58.2183C1.5857 63.5344 4.03943 68.4714 7.65263 72.5055C8.98032 73.9973 10.8462 74.9006 12.8399 75.0166C14.8336 75.1327 16.7917 74.452 18.2835 73.1243C19.7752 71.7966 20.6785 69.9307 20.7945 67.937C20.9106 65.9433 20.2299 63.9852 18.9022 62.4935C16.9793 60.3414 15.7182 57.6802 15.2699 54.8293C14.8217 51.9783 15.2055 49.0586 16.3752 46.4203C17.5449 43.782 19.4509 41.5372 21.8646 39.9551C24.2783 38.373 27.0971 37.5208 29.983 37.5007H31.0517C32.7134 37.4994 34.3276 36.9464 35.6409 35.9283C36.9542 34.9102 37.8922 33.4848 38.3077 31.8759C39.5293 27.0514 42.325 22.7721 46.2524 19.7152C50.1797 16.6584 55.0144 14.9986 59.9912 14.9986C64.968 14.9986 69.8026 16.6584 73.73 19.7152C77.6573 22.7721 80.4531 27.0514 81.6747 31.8759C82.0901 33.4848 83.0281 34.9102 84.3414 35.9283C85.6547 36.9464 87.269 37.4994 88.9307 37.5007H89.9806C92.8729 37.5064 95.7019 38.3482 98.1267 39.9247C100.552 41.5012 102.469 43.7452 103.648 46.3863C104.827 49.0274 105.217 51.9531 104.771 54.8108C104.326 57.6686 103.063 60.3366 101.136 62.4935C100.479 63.2321 99.9736 64.093 99.6489 65.027C99.3242 65.961 99.1866 66.9498 99.2441 67.937C99.3015 68.9242 99.5529 69.8904 99.9837 70.7804C100.415 71.6704 101.017 72.4669 101.755 73.1243C102.494 73.7817 103.355 74.2872 104.289 74.6119C105.223 74.9365 106.212 75.0741 107.199 75.0166C108.186 74.9592 109.152 74.7078 110.042 74.277C110.932 73.8461 111.729 73.2442 112.386 72.5055C115.999 68.4714 118.453 63.5344 119.487 58.2183C120.521 52.9022 120.096 47.4054 118.259 42.3111C116.421 37.2168 113.238 32.715 109.048 29.2834C104.859 25.8517 99.8182 23.6183 94.4617 22.82C91.6084 16.0549 86.8234 10.2815 80.7055 6.22209C74.5875 2.16266 67.4084 -0.00250244 60.0662 -0.00250244C52.724 -0.00250244 45.5448 2.16266 39.4269 6.22209C33.309 10.2815 28.524 16.0549 25.6707 22.82H25.5769Z"
        fill="white"
      />
      <path
        d="M59.9829 119.997C61.972 119.997 63.8796 119.207 65.286 117.801C66.6925 116.394 67.4826 114.487 67.4826 112.498V78.1116L74.9823 85.6113C76.2363 86.9252 77.9095 87.7603 79.7134 87.9725C81.5172 88.1847 83.3385 87.7608 84.8632 86.7738C85.767 86.1483 86.5224 85.3319 87.0757 84.3821C87.629 83.4324 87.9669 82.3727 88.0652 81.2779C88.1636 80.1832 88.0202 79.0802 87.645 78.0471C87.2699 77.0139 86.6723 76.0758 85.8944 75.2992L71.57 61.0123C68.4912 57.9427 64.3211 56.2191 59.9735 56.2191C55.626 56.2191 51.4559 57.9427 48.3771 61.0123L34.0339 75.2992C33.2561 76.0758 32.6584 77.0139 32.2833 78.0471C31.9082 79.0802 31.7647 80.1832 31.8631 81.2779C31.9615 82.3727 32.2993 83.4324 32.8526 84.3821C33.406 85.3319 34.1613 86.1483 35.0652 86.7738C36.5912 87.773 38.4192 88.2058 40.2313 87.9968C42.0434 87.7879 43.7249 86.9504 44.9835 85.6301L52.4832 78.1304V112.498C52.4832 114.487 53.2734 116.394 54.6798 117.801C56.0863 119.207 57.9939 119.997 59.9829 119.997Z"
        fill={colors.primary.pink}
      />
    </svg>
  )
}

export const ClickIcon: FC<IconSvgProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || undefined}
      height={height || undefined}
      {...props}
      viewBox="0 0 116 120"
      fill="none"
    >
      <path
        d="M111.693 41.4949H103.418C99.6818 16.0698 88.81 0 74.8932 0C62.9753 0 53.2429 11.7129 48.2366 32.0642C47.7412 34.0077 48.0306 36.0702 49.0413 37.7981C50.052 39.526 51.7011 40.7778 53.6258 41.278C55.5506 41.7782 57.5933 41.486 59.3046 40.4655C61.0159 39.445 62.2557 37.7799 62.7511 35.8365C66.263 21.5019 71.9604 15.0891 74.9119 15.0891C78.4425 15.0891 85.186 23.9162 88.2682 41.4949H79.227C78.3883 41.4965 77.5682 41.7449 76.8671 42.2097C76.1659 42.6745 75.6141 43.3356 75.2792 44.112C74.9443 44.8884 74.8407 45.7466 74.9812 46.5815C75.1216 47.4164 75.5 48.1919 76.0701 48.8131L89.5945 63.4306C90.3459 64.2415 91.2543 64.888 92.2632 65.33C93.2722 65.772 94.3603 66 95.4601 66C96.5599 66 97.648 65.772 98.657 65.33C99.666 64.888 100.574 64.2415 101.326 63.4306L114.85 48.8131C115.42 48.1919 115.799 47.4164 115.939 46.5815C116.08 45.7466 115.976 44.8884 115.641 44.112C115.306 43.3356 114.754 42.6745 114.053 42.2097C113.352 41.7449 112.532 41.4965 111.693 41.4949Z"
        fill={colors.primary.pink}
      />
      <path
        d="M7.5 66C11.6421 66 15 62.6421 15 58.5C15 54.3579 11.6421 51 7.5 51C3.35786 51 0 54.3579 0 58.5C0 62.6421 3.35786 66 7.5 66Z"
        fill="white"
      />
      <path
        d="M7.5 36C11.6421 36 15 32.6421 15 28.5C15 24.3579 11.6421 21 7.5 21C3.35786 21 0 24.3579 0 28.5C0 32.6421 3.35786 36 7.5 36Z"
        fill="white"
      />
      <path
        d="M95.5 96C99.6421 96 103 92.6421 103 88.5C103 84.3579 99.6421 81 95.5 81C91.3579 81 88 84.3579 88 88.5C88 92.6421 91.3579 96 95.5 96Z"
        fill="white"
      />
      <path
        d="M29.9184 120C43.8047 120 54.6632 103.937 58.4385 78.5225H66.6618C67.5062 78.5229 68.3324 78.2746 69.0388 77.8081C69.7453 77.3416 70.3014 76.6771 70.6388 75.8963C70.9762 75.1154 71.0803 74.2522 70.9382 73.4125C70.7961 72.5729 70.4141 71.7934 69.8391 71.1696L56.3453 56.5771C55.595 55.764 54.6867 55.1156 53.677 54.6722C52.6674 54.2288 51.578 54 50.4768 54C49.3756 54 48.2862 54.2288 47.2766 54.6722C46.2669 55.1156 45.3586 55.764 44.6083 56.5771L31.1145 71.1696C30.5395 71.7934 30.1575 72.5729 30.0154 73.4125C29.8733 74.2522 29.9774 75.1154 30.3148 75.8963C30.6522 76.6771 31.2083 77.3416 31.9147 77.8081C32.6212 78.2746 33.4474 78.5229 34.2917 78.5225H43.2814C40.1976 96.0939 33.432 104.917 29.9184 104.917C26.4048 104.917 21.0222 97.3759 17.7703 84.1785C17.3019 82.2309 16.0857 80.5508 14.3893 79.5077C12.6929 78.4647 10.6552 78.1442 8.7246 78.6167C6.79394 79.0893 5.12844 80.3161 4.09448 82.0274C3.06052 83.7387 2.7428 85.7942 3.21121 87.7418C7.62192 106.086 16.6302 120 29.9184 120Z"
        fill="white"
      />
    </svg>
  )
}

export const StartIcon: FC<IconSvgProps> = ({
  size = 16,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      width={size || width}
      {...props}
      viewBox="0 0 16 18"
      fill="none"
    >
      <path
        d="M5.32645 13.6877C5.41017 13.817 5.52175 13.9259 5.65302 14.0065C5.78429 14.087 5.93192 14.1372 6.08508 14.1532C6.23825 14.1693 6.39308 14.1509 6.53822 14.0994C6.68336 14.0479 6.81513 13.9645 6.92387 13.8555L9.69032 11.089C9.99658 10.7895 10.2351 10.4279 10.3897 10.0284C10.5911 9.50384 10.6362 8.93214 10.5194 8.38251C10.4026 7.83288 10.129 7.3289 9.73161 6.93161L6.92387 4.13935C6.81698 4.03229 6.68786 3.95003 6.54566 3.8984C6.40346 3.84676 6.25164 3.82702 6.10096 3.84056C5.95028 3.8541 5.80442 3.9006 5.6737 3.97676C5.54298 4.05292 5.4306 4.15688 5.34451 4.28129C5.20817 4.49098 5.14953 4.74179 5.17875 4.9902C5.20798 5.23861 5.32323 5.46896 5.50451 5.64129L7.82709 7.96387H1.03226C0.758486 7.96387 0.495927 8.07262 0.302341 8.26621C0.108756 8.45979 0 8.72235 0 8.99612C0 9.2699 0.108756 9.53245 0.302341 9.72604C0.495927 9.91963 0.758486 10.0284 1.03226 10.0284H7.82967L5.48387 12.3768C5.31204 12.5446 5.20294 12.7663 5.17476 13.0049C5.14658 13.2434 5.20103 13.4845 5.32903 13.6877"
        fill="white"
      />
      <path
        d="M10.9858 14.9316L10.6865 14.9781C10.5507 14.9963 10.42 15.0413 10.3019 15.1106C10.1838 15.1798 10.0806 15.2719 9.99842 15.3814C9.91622 15.4909 9.85663 15.6157 9.82311 15.7484C9.78959 15.8812 9.78282 16.0193 9.80319 16.1547C9.82356 16.2901 9.87066 16.4201 9.94176 16.5371C10.0129 16.6541 10.1065 16.7558 10.2173 16.8363C10.3281 16.9168 10.4538 16.9744 10.587 17.0058C10.7203 17.0372 10.8585 17.0418 10.9935 17.0193L11.3781 16.9574C12.4634 16.7674 13.4628 16.2446 14.2377 15.4613C15.0127 14.678 15.5248 13.6731 15.7032 12.5858C15.9007 11.3994 15.9999 10.1988 16 8.99612C16 7.79343 15.9008 6.5928 15.7032 5.40644C15.5235 4.3209 15.0111 3.31796 14.2368 2.53623C13.4625 1.7545 12.4644 1.23258 11.3806 1.04258L10.9961 0.98064C10.8611 0.958145 10.7229 0.962745 10.5896 0.994173C10.4563 1.0256 10.3307 1.08323 10.2199 1.1637C10.1091 1.24417 10.0154 1.34587 9.94434 1.46289C9.87325 1.57991 9.82614 1.7099 9.80577 1.8453C9.7854 1.9807 9.79217 2.1188 9.82569 2.25156C9.85921 2.38432 9.9188 2.50908 10.001 2.61858C10.0832 2.72808 10.1864 2.82014 10.3045 2.88939C10.4226 2.95863 10.5533 3.00369 10.689 3.02193L10.9884 3.06838C11.6606 3.1792 12.2813 3.49756 12.7635 3.97885C13.2458 4.46014 13.5653 5.08024 13.6774 5.75225C13.8523 6.82463 13.9386 7.90958 13.9355 8.99612C13.9385 10.0827 13.8522 11.1676 13.6774 12.24C13.5666 12.9138 13.2474 13.5359 12.7645 14.0187C12.2817 14.5015 11.6596 14.8208 10.9858 14.9316Z"
        fill="white"
      />
    </svg>
  )
}

export const UnlimitedPlanIcon: FC<IconSvgProps> = ({
  size = 23,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      {...props}
      viewBox="0 0 100 100"
      fill="none"
    >
      <path
        fill={colors.primary.DEFAULT}
        d="M82.888 43.413a4.746 4.746 0 00-4.383-2.938H64.167L78.1 9.163a4.757 4.757 0 00-.355-4.51A4.775 4.775 0 0073.768 2.5h-38a4.772 4.772 0 00-4.51 3.243L16.997 48.505a4.706 4.706 0 00.659 4.282 4.742 4.742 0 003.85 1.976h16.34L26.471 91.344a4.722 4.722 0 002.077 5.472c.76.456 1.621.684 2.457.684a4.8 4.8 0 003.37-1.393l47.5-47.5c1.342-1.394 1.748-3.42 1.013-5.194z"
        data-original="#000000"
      ></path>
    </svg>
  )
}
export const InfoIcon: FC<IconSvgProps> = ({
  size = 20,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.83123 8.22598C7.15956 8.33064 7.24807 8.49167 7.16479 8.83212C7.0933 9.12436 7.02129 9.41647 6.94928 9.70859C6.81737 10.2437 6.68545 10.7788 6.55672 11.3148C6.40915 11.9296 6.72059 12.4323 7.31072 12.4779C8.18418 12.5452 8.96375 12.2569 9.66467 11.7509C9.73898 11.6973 9.79639 11.5642 9.78862 11.4743C9.78508 11.4339 9.70538 11.3988 9.63 11.3656C9.60353 11.3539 9.57759 11.3424 9.55568 11.3311C9.53172 11.3187 9.50428 11.3131 9.47682 11.3075C9.46366 11.3048 9.45049 11.3021 9.43771 11.2987C9.04718 11.1943 8.94551 11.031 9.04 10.6412C9.10475 10.3739 9.17088 10.1068 9.23701 9.83975C9.37075 9.29963 9.50449 8.75952 9.62684 8.21686C9.6702 8.02489 9.67334 7.8042 9.6246 7.61492C9.51605 7.19329 9.1469 6.99847 8.58309 7.01477C7.85929 7.03839 7.21219 7.28898 6.61473 7.684C6.56419 7.71749 6.51575 7.7586 6.47748 7.8054C6.34112 7.97181 6.38777 8.1128 6.59335 8.16633C6.62315 8.1741 6.65323 8.18096 6.68331 8.18783C6.73305 8.19917 6.78277 8.21052 6.83123 8.22598ZM9.08799 3.20006C9.8245 3.205 10.4012 3.79363 10.4 4.53941C10.3989 5.26216 9.80432 5.8523 9.07977 5.8499C8.33654 5.84736 7.75014 5.26829 7.74386 4.53059C7.73743 3.79049 8.33908 3.19513 9.08799 3.20006Z"
        fill="white"
      />
    </svg>
  )
}
